import NavigationLayout from "../navigation/navigation-layout.js";
import AboutView from './about-view.js';
import FooterLayout from '../footer/footer-layout.js';
import { useEffect } from "react";

const AboutLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <AboutView />

            <FooterLayout />
        </>
    );
}

export default AboutLayout;